export function resolveNutritionPlanEditorPersistedSessionState({
  planId,
  isEditing = false,
  mealsHydrated = false,
} = {}) {
  const shouldWatchPersistedPlan = Boolean(planId) && Boolean(isEditing);
  const isMealsLoading = shouldWatchPersistedPlan && mealsHydrated !== true;

  return {
    shouldWatchPersistedPlan,
    isMealsLoading,
  };
}
